import { withStyles } from "@material-ui/core";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const style = () => ({
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "#00000085",
    zIndex:" 9999", /* Make sure it's above other content */
  },
});

const ToastModal = ({ toastMessage, toastMessageType, classes, toastUpdate }) => {
  const [isToastOpen, setIsToastOpen] = useState(false);
  const toastId = React.useRef(null);
  const { authToken } = useSelector((state) => state.login.authData);
  const dispatch = useDispatch();
  const toastParameter = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onClose: (reason) => {
        if(!reason)
          setIsToastOpen(false);
        toastUpdate("", "", false);
    },
  };
  const handleClose = async () =>{
      dispatch({ type: "SIGNOUT" });
      sessionStorage.removeItem('session');
      const result = await apiHandler({
        url: endpoint.APP_URL,
        authToken: authToken,
      });
        window.location.href = result?.data?.main
      toastUpdate("","",false);
      setIsToastOpen(false);
  }

  useEffect(() => {
    const message = toastMessage?.toLowerCase();
    if (
      message?.includes("session timeout") ||
      message?.includes("access token") ||
      message?.includes("authorization header")
    ) {
    handleClose();
    }else{
      let updatedMessage = toastMessage;
      const technicalKeywords = ["sql", "query", "table"];
      if ( toastMessage && technicalKeywords.some((keyword) => toastMessage.toLowerCase().includes(keyword) )) {
        updatedMessage = "There is some technical problem. Please contact the support team.";} 
    if (toastMessage && !isToastOpen) {
      if (!toast.isActive(toastId.current)) {
        setIsToastOpen(true);
        switch (toastMessageType) {
          case "Error":
            toastId.current = toast.error(updatedMessage, toastParameter);
            break;
          case "Success":
            toastId.current = toast.success(updatedMessage, toastParameter);
            break;
          case "Information":
            toastId.current = toast.info(updatedMessage, toastParameter);
            break;
          case "Warning":
            toastId.current = toast.warn(updatedMessage, toastParameter);
            break;
          default:
            break;
        }
      }
    }
  }
  }, [toastMessage, toastMessageType, toastUpdate]);

  return (
    <>
      {isToastOpen && <div className={classes.overlay}></div>}
      <ToastContainer />
    </>
  );
};

export default withStyles(style)(ToastModal);
